<template>
    <v-dialog
        max-width="400px"
        persistent
        v-model="openDialog">
        <template v-slot:activator="{ on }">
            <slot :on="on" name="open"></slot>
        </template>
        <v-card color="white">
            <v-card-title>
                Abmelden
            </v-card-title>
            <v-card-text class="pb-2">
                <div class="mt-4">
                    Sind Sie sicher, dass Sie sich abmelden wollen?
                </div>
            </v-card-text>
            <v-card-actions>
                <v-spacer/>
                <v-btn @click="logout" :disabled="disableLogout" text>Abmelden</v-btn>
                <v-btn @click="openDialog = false" text>Abbrechen</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class LogoutDialog extends Vue {
    openDialog: boolean = false;

    private disableLogout:boolean = false;
    async logout(): Promise<void> {

        this.disableLogout = true;
        await this.$ports.b2bAuth.logout();
        await this.$store.commit("Auth/setAuthToken",'');
        await this.$store.commit("Auth/setLoggedIn",false);
        await this.$store.commit("Auth/setUserId","");
        await this.$store.commit("Auth/setCustomerId","");
        await this.$store.commit("Base/setCaller", "")
        await this.$router.replace("/login");
        this.disableLogout = false;

    }
}
</script>

<style scoped>

</style>
